import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import _ from "lodash";

import ContentWrapper from "../../../Wrapper";

import AccountDetailsSubheader from "../../components/account-details-subheader";

import { getAccountCampaignSummaryRequest } from "../../store/actions/account_campaign_summary_actions";
import { CustomEmptyPage } from "../../../../components/empty_page/custom-empty-page";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import { ContentLoadingWithoutCard } from "../../../../components/loading";
import { campaignOptionObj } from "../../../campaign-live-status-v2/constants";
import CampaignSummaryReportFilter from "./summary-report-filter";


const columns = {
  email: [
    { title: "Date", apiKeyName: "date", fieldInputType: "INPUT" },
    { title: "Timezone", apiKeyName: "timezone", fieldInputType: "INPUT" },
    { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },


    { title: "Total Sent", apiKeyName: "sent", fieldInputType: "INPUT" },
    { title: "Opened", apiKeyName: "opened", fieldInputType: "INPUT" },
    { title: "Clicked", apiKeyName: "clicked", fieldInputType: "INPUT" },
    { title: "Bounce", apiKeyName: "bounce", fieldInputType: "INPUT" },
    { title: "Complaint", apiKeyName: "complaint", fieldInputType: "INPUT" },
    { title: "Unsubscribed", apiKeyName: "unsubscribed", fieldInputType: "INPUT" },
    { title: "Failed", apiKeyName: "failed", fieldInputType: "INPUT" },
    { title: "Cost", apiKeyName: "cost", fieldInputType: "INPUT" },
  ],
  sms: [
    { title: "Date", apiKeyName: "date", fieldInputType: "INPUT" },
    { title: "Timezone", apiKeyName: "timezone", fieldInputType: "INPUT" },
    { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },

    { title: "Total Audience", apiKeyName: "sent", fieldInputType: "INPUT" },
    { title: "Total SMS Sent", apiKeyName: "smsSent", fieldInputType: "INPUT" },
    { title: "Delivered", apiKeyName: "smsDelivered", fieldInputType: "INPUT" },
    { title: "Submitted", apiKeyName: "smsSubmitted", fieldInputType: "INPUT" },
    { title: "Undelivered", apiKeyName: "smsUndelivered", fieldInputType: "INPUT" },
    { title: "Cost", apiKeyName: "cost", fieldInputType: "INPUT" },
  ],
  whatsapp: [
    { title: "Date", apiKeyName: "date", fieldInputType: "INPUT" },
    { title: "Timezone", apiKeyName: "timezone", fieldInputType: "INPUT" },
    { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },

    { title: "Total Sent", apiKeyName: "sent", fieldInputType: "INPUT" },
    { title: "Delivered", apiKeyName: "delivered", fieldInputType: "INPUT" },
    { title: "Failed", apiKeyName: "failed", fieldInputType: "INPUT" },
    { title: "Read", apiKeyName: "read", fieldInputType: "INPUT" },
    { title: "Cost", apiKeyName: "cost", fieldInputType: "INPUT" },
  ],
  rcs: [
    { title: "Date", apiKeyName: "date", fieldInputType: "INPUT" },
    { title: "Timezone", apiKeyName: "timezone", fieldInputType: "INPUT" },
    { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },

    { title: "Total Sent", apiKeyName: "sent", fieldInputType: "INPUT" },
    { title: "Delivered", apiKeyName: "delivered", fieldInputType: "INPUT" },
    { title: "Failed", apiKeyName: "failed", fieldInputType: "INPUT" },
    { title: "Read", apiKeyName: "read", fieldInputType: "INPUT" },
    { title: "Cost", apiKeyName: "cost", fieldInputType: "INPUT" },
  ]
};

export default function CampaignSummary({ match }) {
  const tabName = "Summary";

  const [show, setShow] = useState(false);
  const [updatedData, setUpdatedData] = useState([]);

  const [accountId, setAccountId] = useState();
  const [startDate, setStartDate] = useState(dayjs().startOf('month').valueOf());
  const [endDate, setEndDate] = useState(dayjs().endOf('month').valueOf());
  const [channel, setChannel] = useState("sms");
  const [type, setType] = useState("all");

  const [initalFilterValue, setInitialFilterValue] = useState({
    channel: "sms",
    type: "all",
    fromDate: dayjs().startOf("month").valueOf(),
    toDate: dayjs().endOf("month").valueOf(),
  });


  const disptach = useDispatch();

  const store = useSelector((state) => state.accounts.summary);
  useEffect(() => {
    if (!accountId || !startDate || !endDate || !channel || !type) return;
    disptach(getAccountCampaignSummaryRequest({ accountId, startDate, endDate, channel, type }));
  }, [accountId, startDate, endDate, channel, type, disptach]);

  useEffect(() => {
    setAccountId(match.params.accountId);
  }, [match.params.accountId]);

  useEffect(() => {
    if (!_.isEmpty(store.data)) {
      const options = [],
        total = {
          sent: 0,
          opened: 0,
          clicked: 0,
          bounce: 0,
          complaint: 0,
          unsubscribed: 0,
          total: 0,
          failed: 0,
          cost: 0,
          smsSent: 0,
          smsSent2: 0,
          smsDelivered: 0,
          smsSubmitted: 0,
          smsUndelivered: 0,
          delivered: 0,
          read: 0,
          deleted: 0
        };
      store.data.map((each) => ({ ...each, smsSent2: each.smsSent })).forEach((each) => {
        options.push(each);
        for (let key in each) {
          if (total.hasOwnProperty(key)) {
            total[key] = _.round(total[key] + each[key], 4);
          }
          if (
            key === "opened" ||
            key === "clicked" ||
            key === "bounce" ||
            key === "complaint" ||
            key === "unsubscribed" || key === "delivered" || key === "read" || key === "deleted" || key === "failed"
          ) {
            each[key] = `${each[key]} (${Math.round((each[key] / each.sent) * 100)}%)`;
          }
          else if (key === "smsSent" ||
            key === "smsDelivered" ||
            key === "smsSubmitted" ||
            key === "smsUndelivered") {
            each[key] = `${each[key]} (${Math.round((each[key] / each.smsSent2) * 100)}%)`;
          }
        }
      });
      for (let key in total) {
        if (
          key === "opened" ||
          key === "clicked" ||
          key === "bounce" ||
          key === "complaint" ||
          key === "unsubscribed" || key === "delivered" || key === "read" || key === "deleted" || key === "failed"
        ) {
          total[key] = `${total[key]} (${Math.round((total[key] / total.sent) * 100)}%)`;
        }
        else if (key === "smsSent" ||
          key === "smsDelivered" ||
          key === "smsSubmitted" ||
          key === "smsUndelivered") {
          total[key] = `${total[key]} (${Math.round((total[key] / total.smsSent2) * 100)}%)`;
        }
      }
      options.push(total);
      setUpdatedData(options);
    }
    else {
      setUpdatedData([]);
    }
  }, [store.data]);



  const handleApplyFilter = (data) => {
    setType(data.type);
    setStartDate(data.fromDate);
    setEndDate(data.toDate);
    setChannel(data.channel);
    setShow(false);
    setInitialFilterValue(data);
  };

  const handleCancelFilter = () => {
    setShow(false);
  };

  return <ContentWrapper
    subHeader={
      <AccountDetailsSubheader active={tabName}>
        <div className="d-flex gap-3 align-items-center">
          {channel && <div className="badge badge-light-primary fs-7">{campaignOptionObj[channel]}</div>}
          {type && <div className="badge badge-light-primary fs-7">{campaignOptionObj[type]}</div>}
          {startDate && endDate && (
            <div className="badge badge-light-primary fs-7">
              {dayjs(startDate).format("MMM DD")}
              {" - "}
              {dayjs(endDate).format("MMM DD")}
            </div>
          )}
          <CampaignSummaryReportFilter show={show} setShow={setShow} filterValue={initalFilterValue} handleApplyFilter={handleApplyFilter} handleCancelFilter={handleCancelFilter} />
        </div>
      </AccountDetailsSubheader>
    }
  >
    {store.loading ? (
      <ContentLoadingWithoutCard />
    ) : store.data.length === 0 ? (
      <CustomEmptyPage page="no-report" />
    ) : (
      <div className={`card card-custom`}>
        <div className="card-body py-3 px-3" style={{ padding: 15 }}>
          <AdvanceDataTable
            columns={columns[channel]}
            data={updatedData || []}
            limit={store.data?.length || 0}
            pageNo={1}
            setLimit={() => { }}
            setPageNo={() => { }}
            count={store.data?.length || 0}
          />
        </div>
      </div>
    )}
  </ContentWrapper>
}